import React from 'react';

const SEV_OF = (state) => {
  const lvl = (state?.level || '').toLowerCase();
  if (lvl.includes('critical')) return 'critical';
  if (lvl.includes('disrupt') || lvl.includes('storm')) return 'storm';
  if (lvl.includes('elev')) return 'elevated';
  return 'nominal';
};

export default function AtlasTerminalTopBar({
  state, scoring, signalCount, totalInsights, timestamp, sensorReadiness,
  onSwitchToNova, onSwitchToOrion, onSwitchToVega, onSwitchToShow, onSwitchToCrew, onRefresh,
}) {
  const sev = SEV_OF(state);
  const conf = Math.round((scoring?.finalConfidenceScore || scoring?.final_confidence_score || 0) * 100);
  // Guard against non-parseable timestamps (server sometimes returns empty
  // string / unix millis before canonical clock is ready). Falls back to
  // current client time so the top bar never shows "Invalid Date".
  const ts = (() => {
    const raw = timestamp;
    if (!raw) return new Date().toLocaleTimeString('en-US', { hour12: false });
    const parsed = new Date(raw);
    if (Number.isNaN(parsed.getTime())) {
      return new Date().toLocaleTimeString('en-US', { hour12: false });
    }
    return parsed.toLocaleTimeString('en-US', { hour12: false });
  })();
  const ready = sensorReadiness?.ready_pct != null ? `${Math.round(sensorReadiness.ready_pct)}%` : '—';

  return (
    <div className="atl-topbar" data-testid="atl-topbar">
      <div className="atl-topbar-logo" data-testid="atl-topbar-logo">ATLAS TERMINAL</div>

      <div className="atl-status-chip" style={{ color: `var(--status-${sev})` }} data-testid="atl-status">
        {state?.level || 'NOMINAL'}
      </div>

      <div className="atl-topbar-stat">
        <span className="k">Conf</span>
        <span className="v" data-testid="atl-conf">{conf}%</span>
      </div>
      <div className="atl-topbar-stat">
        <span className="k">Signals</span>
        <span className="v" data-testid="atl-signals">{signalCount ?? '—'}</span>
      </div>
      <div className="atl-topbar-stat">
        <span className="k">Issues</span>
        <span className="v" data-testid="atl-issues">{totalInsights ?? '—'}</span>
      </div>
      <div className="atl-topbar-stat">
        <span className="k">Ready</span>
        <span className="v" data-testid="atl-ready">{ready}</span>
      </div>
      <div className="atl-topbar-stat">
        <span className="k">UTC</span>
        <span className="v">{ts}</span>
      </div>

      <div className="atl-topbar-spacer" />

      <button
        onClick={onRefresh}
        className="studio-chip"
        style={{ cursor: 'pointer', background: 'transparent' }}
        data-testid="atl-refresh-btn"
      >
        ↻ Sync
      </button>

      <div className="atl-agent-switch" data-testid="atl-agent-switch">
        <button onClick={onSwitchToNova} data-testid="atl-switch-nova">NOVA</button>
        <button onClick={onSwitchToOrion} data-testid="atl-switch-orion">ORION</button>
        <button onClick={onSwitchToVega} data-testid="atl-switch-vega">VEGA</button>
        <button className="is-active" data-testid="atl-switch-atlas">ATLAS</button>
        {onSwitchToCrew && <button onClick={onSwitchToCrew} data-testid="atl-switch-crew">CREW</button>}
        <button onClick={onSwitchToShow} data-testid="atl-switch-show">SHOW</button>
      </div>
    </div>
  );
}
